export const isEmpty = (o: any) => {
  if (o === null || o === undefined) {
    return true;
  }
  return (Object.entries(o).length === 0 && o.constructor === Object);
}